import React, { useEffect, useState, useContext } from "react";
import axios from 'axios';
import { Link } from "react-router-dom";
import { AuthContext } from '../../AuthContext';
import Footer from '../../components/Footer'
import Navbar from '../../components/Navbar'
import Pagination from "react-js-pagination";
import { HalfMalf } from 'react-spinner-animated';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faStar } from "@fortawesome/free-solid-svg-icons";

const Module = () => {
    const url = "https://lbw-edunesia.com/api-lbw/public/";
    // const url = "http://localhost:8000/";
    const [module, setModule] = useState(null)
    const [page, setPage] = useState(null)
    const [isPending, setIsPending] = useState(true)
    const { isAuthenticated, setIsAuthenticated } = useContext(AuthContext)
    const [frontend, setFrontend] = useState([]);

    const fetchData = async (pageNumber = 1) => {
        await axios.get(url + 'api/module?page=' + pageNumber)
            .then((response) => {
                //set response user to state
                setModule(response.data.data.data)
                setPage(response.data.data)
                setIsPending(false)
                // setIsFetch(true)
            }).catch(err => console.log(err))
    };

    useEffect(() => {
        if (localStorage.getItem("token")) {
            setIsAuthenticated(true)
        }
        axios.get(url + 'api/frontend')
            .then((response) => {
                //set response user to state
                setFrontend(response.data.data)
                // setIsFetch(true)
            }).catch(err => console.log(err))

        fetchData();
    }, [setIsPending])

    return (
        <React.Fragment>
            {isPending &&
                <HalfMalf text={"Loading..."} bgColor={"#f8f9fa"} center={true} width={"150px"} height={"150px"} />
            }
            {!isPending &&
                <>
                    <Navbar />
                    <div className="inner-banner inner-bg7">
                        <div className="container">
                            <div className="inner-title text-center">
                                <h3>Module</h3>
                                <ul>
                                    <li>
                                        <Link to="/">Home</Link>
                                    </li>
                                    <li>
                                        <i className="bx bxs-chevrons-right" />
                                    </li>
                                    <li>Module</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <section className="portfolio-area pt-100 pb-70">
                        <div className="container">
                            <div className="scetion-title text-center">
                                <span>Module</span>
                                <h2>{frontend.module_text}</h2>
                            </div>
                            <div className="row pt-45">
                                {module.map((mod) => {
                                    return (
                                        <div className="col-lg-4 col-md-6" key={mod.id}>
                                            <div className="portfolio-item">
                                                <div className="portfolio-img">
                                                    <Link to={`module/${mod.id}`}>
                                                        <img src={mod.image} alt="Module Images" width="550" height="350" />
                                                    </Link>
                                                    <div className="portfolio-tag">
                                                        <Link to={`module/${mod.id}`}><span>{mod.category_data.category} (<FontAwesomeIcon icon={faStar} style={{ color: '#ffd700' }} /> {mod.rating})</span></Link>
                                                    </div>
                                                    <div className="portfolio-content">
                                                        {isAuthenticated &&
                                                            <Link to={`module/${mod.id}`}>
                                                                <h3>{mod.nama}</h3>
                                                                <i className="bx bxs-chevron-right" />
                                                            </Link>
                                                        }
                                                        {!isAuthenticated &&
                                                            <Link to="login">
                                                                <h3>{mod.nama}</h3>
                                                                <i className="bx bxs-chevron-right" />
                                                            </Link>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}
                                <div style={{ marginLeft: '40%' }}>
                                    <Pagination
                                        activePage={page?.current_page ? page?.current_page : 0}
                                        itemsCountPerPage={page?.per_page ? page?.per_page : 0}
                                        totalItemsCount={page?.total ? page?.total : 0}
                                        pageRangeDisplayed={page?.per_page ? page?.per_page : 0}
                                        onChange={(pageNumber) => {
                                            fetchData(pageNumber)
                                        }}
                                        itemClass="page-item"
                                        linkClass="page-link"
                                        firstPageText="<<"
                                        lastPageText=">>"
                                        nextPageText=">"
                                        prevPageText="<"
                                    />
                                </div>
                            </div>
                        </div>
                    </section>
                    <Footer />
                </>
            }
        </React.Fragment>
    );
}

export default Module;